import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
declare var jQuery: any;
import "../../../../assets/semantic/semantic.min.js";
import { WarehouseService } from "../../../_services/warehouse.service";


@Component({
  selector: "app-new-warehouse",
  templateUrl: "./new-warehouse.component.html",
  styleUrls: ["./new-warehouse.component.css"],
})
export class NewWarehouseComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private creating_warehouse = false;

  constructor(private warehouseService: WarehouseService) {}

  new_warehouse = new FormGroup({
    name: new FormControl("", [Validators.required]),
    note: new FormControl('')
  });

  ngOnInit() {}

  openModal(warehouse) {
    if (warehouse) this.new_warehouse.patchValue({ name: warehouse, note: warehouse.note });
      jQuery("#add-warehouse-modal").modal({ inverted: true, allowMultiple: true }).modal("show");
  }

  // Update Company
  submitWarehouseForm() {
    this.new_warehouse.disable(); // Disable the form to avoid changes during the Updating process
    this.creating_warehouse = true; // Trigger the Loading button apparition
    jQuery("#add-warehouse-modal").modal({ closable: false }); // Set the modal unclosable during the Updating process
    // Create the Contact
    this.warehouseService.createWarehouse(this.new_warehouse.value).subscribe((response) => {
        jQuery("#add-warehouse-modal").modal({ closable: true }).modal("hide"); // Set the modal closable & Close the modal
        this.creating_warehouse = false; // Disable the loading button apparition
        this.new_warehouse.enable(); // Re Enable the Form
        this.new_warehouse.reset(); // Reset It
        this.refresh.emit(true); // Emmit the refresh Event
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/warehouse/new-warehouse/new-warehouse.component.ts